import React, { useEffect, useRef, useContext } from 'react';
import { gsap } from './gsap';
import './styles/App.scss';
import Header from './components/common-header/Header';
import Footer from './components/common-footer/Footer';
import Cta from './components/cta/Cta';
import Hero from './components/hero/Hero';
import Chapter1 from './components/Chapters/Chapter1';
import Chapter2 from './components/Chapters/Chapter2';
import Chapter3 from './components/Chapters/Chapter3';
import Chapter4 from './components/Chapters/Chapter4';
import { WidthContext, WidthContextProvider } from './WidthContext';
import InlinePhoto from './components/InlinePhotos/InlinePhoto';
import Carousel from './components/carousel/Carousel';

function App() {
  const width = useContext(WidthContext);
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const ctaRef = useRef();
  const titleRef = useRef();
  const authorRef = useRef();
  const carousel1Ref = useRef();
  const carousel2Ref = useRef();
  const carousel3Ref = useRef();
  const belowRef = useRef();
  useEffect(() => {
    const words = gsap.utils.selector(titleRef);

    const tl = gsap.timeline();
    tl.to(
      words('.words'),
      {
        opacity: 1,
        scale: 1,
        duration: 1,
        stagger: 0.2,
        delay: 0.5
      },
      '<'
    )
      .to(authorRef.current, { opacity: 1, duration: 0.7 }, '-=0.5')
      .to(belowRef.current, { opacity: 1, duration: 0.7 }, '-=0.5');
  }, []);

  return (
    <WidthContextProvider>
      <div className="app">
        <Header clientName={"Destination Canada"}/>
        <Hero />
        <h1 className="app__head" ref={titleRef}>
          <span className="words">Canada:</span>
          {width > 767 ? <br /> : ' '}
          <span className="words">A</span> <span className="words">Wide</span>{' '}
          <span className="words">Open</span> <span className="words">Country</span>
        </h1>
        <span className="app__author" ref={authorRef}>
          by Erin Pehlivan
        </span>
        <div className="app__belowFold" ref={belowRef}>
          <Chapter1 />
          <InlinePhoto index={0} photoRef={inline1} />
          <Chapter2 />
          <Carousel dataIndex={0} carouselRef={carousel1Ref} />
          <InlinePhoto index={1} photoRef={inline2} />
          <Chapter3 />
          <Carousel dataIndex={1} carouselRef={carousel2Ref} />
          <InlinePhoto index={2} photoRef={inline3} />
          <Chapter4 />
          <Carousel dataIndex={2} carouselRef={carousel3Ref} />
          <Cta ctaRef={ctaRef} />
          <Footer />
        </div>
      </div>
    </WidthContextProvider>
  );
}

export default App;
